import ReactGA from "react-ga4";

const initializeAnalytics = () => {
    ReactGA.initialize("G-8Z3ZF5MBBX");
};

export default initializeAnalytics;
